RivalIQ.module('behaviors', function (behaviors, Admin, Backbone, Marionette, $, _, s) {

    'use strict';

    function typeConvertor(type) {
        switch (type) {
            case 'number':
                return function (val) { return Number(val); };
            default:
                break;
        }

        return _.identity;
    }

    behaviors.FormValidator = Marionette.Behavior.extend({
        defaults: {
            bindModel: true // Auto update model based on form changes
        },

        ui: {
            formElements: '[name]'
        },

        events: {
            'input @ui.formElements': 'updateFormAttributes',
            'change @ui.formElements': 'updateFormAttributes'
        },

        modelEvents: {
            'invalid': 'onValidationFail',
            'sync': 'onSync',
            'change': 'clearRelevantErrors'
        },

        /*
         * This method maps form controls to our models automatically.
         * Use it by including the FormValidator behavior on your view. By
         * default it auto updates the model. Setting the option bindModel to
         * false will prevent that behavior. If you include .x-validation-msg
         * blocks next to the inputs they will automatically be marked with
         * validation errors.
         *
         * Changes to the form values trigger form:#{name} events on the model
         * model.unsavedAttributes added to model to track all changes since
         * last sync
         *
         * Example basic input:
         * <input type='text', name='first_name'>
         *
         * Nested input (will construct a hash):
         * <input type='text', name='owner[first_name]'>
         *
         * Array value:
         * <input type='checkbox', name='landscapes[]' value='123'>
         *
         * Used in combination with AttributeBuilder for super effect
         * <input type='checkbox', name='landscapes[]' value='123' data-check='true'>
         *
         */
        updateFormAttributes: function () {
            const me = this;

            if (!me.view.model) {
                return;
            }

            const data = me.$('[name]').serializeArray();

            const formAttrs = {};

            _.each(data, function (value) {
                const path = _(value.name.split('[')).map(_.partial(s.rtrim, _, ']'));
                const type = me.$(`[name="${value.name}"]`).data('type');

                let obj = formAttrs;

                path.forEach(function (key, index) {
                    if (key === path.last()) {
                        const val = typeConvertor(type)(value.value);
                        if (_.isArray(obj)) {
                            obj.push(val);
                        } else {
                            obj[key] = val;
                        }
                    } else if (!obj[key]) {
                        if (path.get(index + 1) === '') {
                            obj[key] = obj[key] || [];
                        } else {
                            obj[key] = {};
                        }
                    }

                    obj = obj[key];
                });
            });

            const model = me.view.model;
            let changedAttrs;

            if (me.options.bindModel) {
                model.set(formAttrs);
                changedAttrs = model.changedAttributes() || {};
            } else {
                changedAttrs = model.changedAttributes(formAttrs) || {};
            }

            _.each(formAttrs, function (v, k) {
                model.trigger(`form:${k}`, v);
            });

            model.unsavedAttributes = _.extend({}, model.unsavedAttributes, changedAttrs);
            me.view.formAttrs = formAttrs;
        },

        onBeforeShow: function () {
            const me = this;
            me.updateFormAttributes();
        },

        onSync: function () {
            const me = this;
            me.view.model.savedAttributes = me.view.model.unsavedAttributes;
            me.view.model.unsavedAttributes = {};
        },

        onValidationFail: function (model, validationError, options) {
            const me = this;

            if (options && options.display === false) {
                return;
            }

            _.each(validationError, function (err) {
                me.setError(err[0], err[1]);
            });
            me.clearRelevantErrors();
        },

        setError: function (field, message) {
            const me = this;
            const input = me.$(`[name="${field}"]`);
            const formGroup = input.closest('.form-group');
            formGroup.addClass('has-error');
            formGroup.find('.x-validation-msg').html(message).show();
        },

        clearError: function (field) {
            const me = this;
            const input = me.$(`[name="${field}"]`);
            const formGroup = input.closest('.form-group');
            formGroup.removeClass('has-error');
            formGroup.find('.x-validation-msg').hide();
        },

        clearRelevantErrors: function () {
            const me = this;
            const errors = me.view.model.validationError;

            const fieldsInError = _.map(errors, _.head);
            const resolvedErrorFields = _.difference(_.keys(me.view.model.attributes), fieldsInError);

            _.each(resolvedErrorFields, function (error) {
                me.clearError(error);
            });
        },

        onResetFormAttributes: function () {
            const me = this;
            me.updateFormAttributes();
            me.onResetValidationErrors();
        },

        onResetValidationErrors: function () {
            const me = this;
            const formGroups = me.ui.formElements.closest('.form-group');
            formGroups.removeClass('has-error');
            formGroups.find('.x-validation-msg').hide();
        },

        onDisplayError: function (field, error) {
            const me = this;
            me.setError(field, error);
        }
    });
}, window.s);
